const ADMIN_URL = 'admin-new';
const ADMIN_URL_OLD = 'admin';
const SHOW_ON_DEV = process.env.NODE_ENV === 'development';

const FormMode = {
  CREATE: 'create',
  UPDATE: 'update'
};

export { ADMIN_URL, ADMIN_URL_OLD, SHOW_ON_DEV, FormMode };
